import { Button, Modal } from "antd";
import { useIntl } from "react-intl";
import type { PlacingTableRow } from "~pages/FinalStandings/types/placingTableRow";

type Props = {
  record: PlacingTableRow;
  onDelete: (placingId: string) => void;
};

const DeletePlacingAction = ({ record, onDelete }: Props) => {
  const { formatMessage } = useIntl();
  const [modal, contextHolder] = Modal.useModal();

  const handleClick = () => {
    if (record.placingId) {
      modal.confirm({
        title: formatMessage({ id: "placing.delete" }),
        content: formatMessage({ id: "placing.delete.confirm" }),
        okText: formatMessage({ id: "delete" }),
        okButtonProps: { loading: false },
        onOk: () => onDelete(record.placingId || ""),
      });
    }
  };

  return (
    <>
      {contextHolder}
      <Button
        disabled={!record.placingId}
        onClick={handleClick}
        type={"text"}
        size={"small"}
        icon={<i className="fas fa-trash-can mr-2" />}
      />
    </>
  );
};
export default DeletePlacingAction;
